module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "messages",
    staticClass: "chat-messages"
  }, [_c('transition-group', {
    staticClass: "chat-messages_inner",
    attrs: {
      "name": "messages",
      "tag": "div"
    }
  }, _vm._l((_vm.messages), function(message) {
    return _c('ChatMessage', {
      key: message.id,
      attrs: {
        "message": message
      }
    })
  })), (!_vm.messages.length) ? _c('div', {
    staticClass: "chat-messages_empty"
  }, [_vm._v("Напишите что-нибудь в чат")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-8035a61c"}!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat-messages.vue
// module id = 98
// module chunks = 1